/**
 * Per-axis multipliers when scoring matches (see QUESTION_IMPORTANCE_DATA_MODEL.md).
 * Higher importance → mismatches count more → stronger effect on % match.
 */
export type ImportanceLevel = 'very' | 'not_very' | 'not_at_all';

export const IMPORTANCE_LABELS: { value: ImportanceLevel; label: string }[] = [
  { value: 'not_at_all', label: 'Not at all' },
  { value: 'not_very', label: 'Not very' },
  { value: 'very', label: 'Very' },
];

/**
 * Relative emphasis for UI (vector compare) and `preferences.*.weight` in the request body.
 * Must stay aligned with backend `services/match/lib/importanceWeights.ts`.
 */
const IMPORTANCE_WEIGHT: Record<ImportanceLevel, number> = {
  very: 3,
  not_very: 1,
  not_at_all: 0.28,
};

export function importanceWeight(level: ImportanceLevel): number {
  return IMPORTANCE_WEIGHT[level];
}
